// Makes tables pasted into rich-text areas (product descriptions, pages,
// blog articles - anything rendered inside a .rte block) responsive on
// mobile. Merchants paste plain <table> markup with no knowledge of the
// theme, so there's no card-friendly markup to work with.
//
// Rather than fighting the well-known browser quirk where a <tr> (or <td>)
// with its CSS display overridden to block/flex often won't auto-size its
// own box to its stacked children - it silently keeps its old table-row
// sizing internally and clips/overlaps the rest - this builds a fully
// separate, plain <div>-based card list from the table's data and lets
// CSS swap between the two: the real <table> for desktop (where table
// layout is exactly what's wanted), the generated cards for mobile
// (plain block boxes, no table quirks possible). Both exist in the DOM
// at once; only one is ever visible at a given viewport width.
(function () {
  function buildCards(table) {
    var thead = table.querySelector('thead');
    var headerRow;
    var bodyRows;

    if (thead) {
      headerRow = thead.querySelector('tr');
      bodyRows = Array.prototype.slice.call(table.querySelectorAll('tbody tr'));
    } else {
      // No explicit thead/tbody - browsers still auto-wrap orphan <tr>
      // elements in an implicit <tbody>, so querying 'tr' directly is the
      // only reliable way to get every row including what should be the
      // header (the first one).
      var allRows = Array.prototype.slice.call(table.querySelectorAll('tr'));
      headerRow = allRows[0];
      bodyRows = allRows.slice(1);
    }

    if (!headerRow || !bodyRows.length) return null;

    var headers = Array.prototype.map.call(headerRow.querySelectorAll('th, td'), function (cell) {
      return cell.textContent.trim();
    });
    if (!headers.length) return null;

    var wrapper = document.createElement('div');
    wrapper.className = 'rte-table-cards';

    bodyRows.forEach(function (row) {
      var card = document.createElement('div');
      card.className = 'rte-table-cards__card';

      Array.prototype.forEach.call(row.querySelectorAll('td, th'), function (cell, i) {
        var line = document.createElement('div');
        line.className = 'rte-table-cards__line';

        if (headers[i]) {
          var label = document.createElement('span');
          label.className = 'rte-table-cards__label';
          label.textContent = headers[i];
          line.appendChild(label);
        }

        var value = document.createElement('span');
        value.className = 'rte-table-cards__value';
        // innerHTML (not textContent) so links/bold/etc inside a cell
        // still work in the generated card.
        value.innerHTML = cell.innerHTML;
        line.appendChild(value);

        card.appendChild(line);
      });

      wrapper.appendChild(card);
    });

    return wrapper;
  }

  function enhanceTable(table) {
    if (table.dataset.responsiveEnhanced) return;
    table.dataset.responsiveEnhanced = 'true';

    var cards = buildCards(table);
    if (!cards) return;

    // A data attribute, not a class - global.css has a
    // `table:not([class]) { border-collapse: collapse; ... }` rule that
    // gives plain pasted tables (no class of their own) their clean
    // single-line border. Adding a class here would silently opt this
    // table out of that rule and break its border/shadow styling; a data
    // attribute doesn't affect that selector at all.
    table.setAttribute('data-has-cards', 'true');
    table.insertAdjacentElement('afterend', cards);
  }

  function init() {
    document.querySelectorAll('.rte table').forEach(enhanceTable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
